(function () {
    'use strict';

    angular
        .module('partners')
        .controller('VirtualFairShowController', VirtualFairShowController)

    VirtualFairShowController.$inject = ['$uibModalInstance', 'virtualfair'];

    function VirtualFairShowController($uibModalInstance, virtualfair) {
        var vm = this;


        vm.close = close;
        vm.virtualfair = virtualfair;


        function close() {
            $uibModalInstance.close();
        }
    }

})();